export default __webpack_public_path__ + "static/media/onboardingAside.a492dbcc.png";